import type { CargoRes, CreateCargoItemReq } from 'api/swagger';
import { isPositiveInteger } from 'shared/utils/numbers/is-positive-integer';
import { round100 } from 'shared/utils/numbers/round.ts';

export const calculateTotalLDM = (count: number, stack: number, LDM: number): number => {
  if (!isPositiveInteger(count) || !isPositiveInteger(stack) || !LDM) return 0;

  if (count <= stack) return LDM;

  const remainder = count % stack;
  if (remainder === 0) {
    const result = round100((count / stack) * LDM);
    return result <= 0.01 ? 0.01 : result;
  }

  const result = calculateTotalLDM(count - remainder, stack, LDM) + calculateTotalLDM(remainder, stack, LDM);
  return result <= 0.01 ? 0.01 : round100(result);
};

export const calculateLdm = (length: number, width: number): number => {
  const result = round100((length * width) / 2.4);
  return result <= 0.01 ? 0.01 : result;
};

export const calculateCargoItemsTotalLdm = (cargoItems?: Partial<CreateCargoItemReq>[]): number => {
  const totalLdm = cargoItems?.reduce((total, cargoItem) => {
    const { count, length, width, stack = 1 } = cargoItem;

    if (!count || !length || !width) return total;

    return total + calculateTotalLDM(count, stack, calculateLdm(length, width));
  }, 0);

  return round100(totalLdm ?? 0);
};

export const getLdmForAverageCargoCost = (cargo: CargoRes) => {
  return cargo.totalWeight / 1800 > cargo.totalLDM ? cargo.totalWeight / 1800 : cargo.totalLDM;
};
